var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManBeard1D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "frame_730px_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "beard_x5F_1_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Man_x5F_beards_2_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "beard_x5F_1_2_",
    fill: "#654023",
    d: "M359.3,374.7c3,0,8.5-0.2,11.5-0.1c3.5,0.1,3.7-0.3,3.9,3.4c0.1,2.4,0.2,3.1-0.8,4.5 c-1.9,2.6-5.8,5.1-7.2,6.3c-0.5,0.4-2,2-2.5,2.3c3.2,3.5,5.2,7.6,10.9,8c4.8,0.4,9.6-2,13.7-4.4c4.2-2.6,9.4-6.2,13.4-8.9 c2.6-1.7,8.4-5.6,10.5-5.7c1.2-0.1,3.8,1.6,4.6,2.4c-5.5,7.5-13.9,15-20.7,21.5c-7,6.7-16.5,14.5-25.8,15c-11,0.6-19.9,2-29.8-3.9 c-8.2-4.9-15.7-11.7-23-18c-3.8-3.3-7.9-6.5-11.7-10.4c-1.3-1.3-6.1-5-5.7-6.4c0.7-2.4,4.3-0.8,6.1,0.4c7.8,5,15.9,11,24.3,15 c4.4,2.1,9.7,5.3,14.6,3.5c2.3-0.8,4-2.3,5.6-4.1c0.8-0.9,2.9-3.2,3.2-4.4c0,0-0.4-0.3-1.9-1.8c-2.5-2.4-6.8-4.8-8.1-7.8 c-0.8-1.8-0.8-4.9,0.4-5.8c0.7-0.5,4.7-0.4,5.6-0.5c2.7-0.1,6-0.1,6.9-0.1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManBeard1D);
export default __webpack_public_path__ + "static/media/man_beard_1d.7178b39c10131d271af196799e225787.svg";
export { ForwardRef as ReactComponent };